const countryApi = '/location';

export const getCountriesPath = () => `${countryApi}/countries`;
export const getCitiesPath = () => `${countryApi}/cities`;
